import React from "react"

const BorderedTitle = ({ children }) => (
    <div style={{ borderBottom: `solid 1px white` }}>
        {children}
    </div>
)

export default BorderedTitle